import { push } from 'connected-react-router';
import AppTabs from '../../components/AppTabs';
import * as React from 'react';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Tabs, Tab } from '@material-ui/core';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import './AdministratorDashboard.scss';
import { CommunicationsTab } from './CommunicationsTab';
import { StatsTab } from './StatsTab';
import { ChangeLogTab } from './ChangeLogTab';
import { DebtorsTab } from './DebtorsTab';

export const AdministratorDashboard = () => {
  const t = useTranslations()
  const dispatch = useDispatch()
  const location = useLocation()
  const activeTab = useMemo(() => (location.hash && location.hash.substr(1)) || 'stats', [location.hash])
  const setActiveTab = useCallback(
    (tab: string|undefined) => dispatch(push({
      pathname: location.pathname,
      search: location.search,
      hash: tab ? `#${tab}` : '',
    })),
    [dispatch, location.pathname, location.search])

  return (<>
    <AppTabs value={activeTab} onChange={(_, v) => setActiveTab(v)} indicatorColor="primary" textColor="primary" style={{ borderBottom: 'var(--border-thin) solid var(--appLigthGrey)' }}>
      <Tab label={t(TK.stats)} value="stats" />
      <Tab label={t(TK.debtors)} value="debtors" />
      <Tab label={t(TK.communications)} value="comms" />
      <Tab label={t(TK.changeLog)} value="changeLog" />
    </AppTabs>
    <div className='adminTabsContent'>
        {activeTab === 'stats' && <StatsTab/>}
        {activeTab === 'debtors' && <DebtorsTab/>}
        {activeTab === 'comms' && <CommunicationsTab/>}
        {activeTab === 'changeLog' && <ChangeLogTab/>}
    </div>
  </>)
} 
